import { toast } from "react-hot-toast";

export const successNotification = (text = null) => {
  toast.success(`İşlem başarıyla gerçekleştirildi. ${text ? text : ""}`);
};

export const errorNotification = (text = null) => {
  toast.error(`Bir hata oluştu. ${text ? text : ""}`);
};
